import React from 'react';
import { Box, Button } from '@mui/material';
import { Save, ArrowRight } from 'lucide-react';

interface IntakeFormActionsProps {
  activeStep: number;
  isValid: boolean;
  onCancel: () => void;
  onBack?: () => void;
  onNext: () => void;
}

export const IntakeFormActions: React.FC<IntakeFormActionsProps> = ({
  activeStep,
  isValid,
  onCancel,
  onBack,
  onNext,
}) => {
  const isLastStep = activeStep === 1;

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2, 
      justifyContent: { sm: 'flex-end' }, 
      mt: 4,
    }}>
      <Button
        onClick={onCancel}
        color="inherit"
        fullWidth
        sx={{ order: { xs: 3, sm: 1 } }}
      >
        Cancel
      </Button>
      {activeStep > 0 && onBack && (
        <Button
          onClick={onBack}
          color="inherit"
          fullWidth
          sx={{ order: { xs: 2, sm: 2 } }}
        >
          Back
        </Button>
      )}
      <Button
        onClick={onNext}
        variant="contained"
        startIcon={isLastStep ? <Save /> : <ArrowRight />}
        disabled={!isValid}
        fullWidth
        sx={{ order: { xs: 1, sm: 3 } }}
      >
        {isLastStep ? 'Create Case' : 'Next'}
      </Button>
    </Box>
  );
};